@charset "UTF-8";

/* src/app/modules/print-cards/components/print-labels/label-content/avery-94200-label-stack-content/avery-94200-label-stack-content.component.scss */
.f12px {
  font-size: 0.75rem;
}
.f14px {
  font-size: 0.875rem;
}
.f16px {
  font-size: 1rem;
}
.f18px {
  font-size: 1.125rem;
}
.f20px {
  font-size: 1.25rem;
}
.f24px {
  font-size: 1.5rem;
}
.f32px {
  font-size: 2rem;
}
.f48px {
  font-size: 3rem;
}
.f64px {
  font-size: 4rem;
}
.inventory-label {
  height: 100%;
  width: 100%;
  max-height: 100%;
  max-width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  padding: 0.5rem;
  gap: 0.5rem;
}
.inventory-label .left-side-content {
  width: 3.125rem;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.inventory-label .left-side-content .brand-logo {
  max-width: 3.125rem;
  max-height: 100%;
}
.inventory-label .center-content {
  flex: 1;
  color: black;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 0.5rem;
}
.inventory-label .center-content .name-and-brand {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 0.125rem;
  justify-content: center;
  align-items: flex-start;
}
.inventory-label .center-content .name-and-brand .product-name-text {
  font-family: poppins, sans-serif;
  font-weight: 700;
  font-size: 0.75rem;
  line-height: 116%;
}
.inventory-label .center-content .name-and-brand .brand-name-text {
  font-family: poppins, sans-serif;
  font-weight: 500;
  font-size: 0.625rem;
  line-height: 100%;
}
.inventory-label .center-content .size-and-variant-type {
  display: flex;
  flex-direction: row;
  gap: 0.25rem;
  align-items: center;
}
.inventory-label .center-content .size-and-variant-type .size-text {
  font-family: poppins, sans-serif;
  font-weight: 700;
  font-size: 0.625rem;
  font-style: italic;
  line-height: 100%;
}
.inventory-label .center-content .size-and-variant-type .variant-type-text {
  overflow: clip;
  overflow-clip-margin: 0.1rem;
  text-overflow: ellipsis;
  white-space: normal;
  display: -webkit-box;
  word-break: break-all;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  font-family: poppins, sans-serif;
  font-weight: 500;
  font-size: 0.5625rem;
  line-height: 111%;
}
.inventory-label .right-side-content {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.inventory-label .right-side-content .product-image-stamp {
  border-radius: 50%;
  width: 2rem;
  height: 2rem;
  display: flex;
  justify-content: center;
  align-items: center;
}
.inventory-label .right-side-content .product-image-stamp .product-image {
  max-width: 1.5rem;
  max-height: 1.4rem;
}
/*# sourceMappingURL=avery-94200-label-stack-content.component.css.map */
